/**
 * Kennisbank (MILO-221) deep links used by the in-app help panel (MILO-422).
 *
 * The help panel links to a support article with `data-milo-kb-article`, which
 * the support widget's host bridge intercepts to render the article in its own
 * panel instead of navigating away. The `href` stays a real kennisbank URL on
 * purpose: when no widget is mounted (feature flag off, or no `ai_bots` until
 * MILO-417) the browser simply follows the link.
 */
export interface KnowledgeBaseEnvironment {
    VITE_MILO_KB_BASE_URL?: string;
    // The resolver reads a single variable out of a much larger env object; the
    // index signature keeps `import.meta.env` assignable to it.
    [key: string]: unknown;
}

export const DEFAULT_MILO_KB_BASE_URL = 'https://support.milomoves.nl';

export function resolveKnowledgeBaseUrl(environment: KnowledgeBaseEnvironment): string {
    return (environment.VITE_MILO_KB_BASE_URL ?? DEFAULT_MILO_KB_BASE_URL).replace(/\/$/, '');
}

/**
 * Locale root of the generated kennisbank, mirroring `LOCALES` in the milo-ai
 * build script: Dutch articles live under `/kb/`, English under `/en/kb/`.
 */
export function knowledgeBasePath(locale: string): string {
    return locale.trim().toLowerCase().startsWith('en') ? '/en/kb/' : '/kb/';
}
